import { useState } from "react";
import BetaChipLogo from "../../images/main/betachip.png"

export default function Navbar({ setActiveComponent }) {
  const [activeTab, setActiveTab] = useState('welcome');
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setActiveComponent(tabName);
  };

  return (
    <div className="navbar">
      <div className="betaChipLogoContainer">
        <img className="betaChipLogo" src={BetaChipLogo} alt="Betachip" />
      </div>
      <button className={activeTab === 'welcome' ? 'active' : ''} onClick={() => handleTabClick('welcome')}>
        Welcome
      </button>
      <button className={activeTab === 'collection' ? 'active' : ''} onClick={() => handleTabClick('collection')}>
        Collection
      </button>
      <button className={activeTab === 'tasks' ? 'active' : ''} onClick={() => handleTabClick('tasks')}>
        Tasks
      </button>
      <button className={activeTab === 'openBoosters' ? 'active' : ''} onClick={() => handleTabClick('openBoosters')}>
        Open Boosters
      </button>
      <button className={activeTab === 'saveLoad' ? 'active' : ''} onClick={() => handleTabClick('saveLoad')}>
        Save/Load
      </button>
      {/* <button className={activeTab === 'credits' ? 'active' : ''} onClick={() => handleTabClick('credits')}>
        Credits
      </button> */}
    </div>
  );
}